import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPenTool = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='m12 19-.707-.707a1 1 0 0 0 0 1.414zm7-7 .707-.707a1 1 0 0 0-1.414 0zm3 3 .707.707a1 1 0 0 0 0-1.414zm-7 7-.707.707a1 1 0 0 0 1.414 0zm3-9 .707.707a1 1 0 0 0 .274-.903zm-1.5-7.5.98-.196a1 1 0 0 0-.745-.776zM2 2l.235-.972a1 1 0 0 0-1.207 1.207zm3.5 14.5-.972.235a1 1 0 0 0 .776.746zM13 18l-.196.98a1 1 0 0 0 .903-.273zm-4.121-7.707a1 1 0 0 0 1.414-1.414zm3.828 9.414 7-7-1.414-1.414-7 7zm5.586-7 3 3 1.414-1.414-3-3zm3 1.586-7 7 1.414 1.414 7-7zm-5.586 7-3-3-1.414 1.414 3 3zm3.274-8.49-1.5-7.5-1.962.393 1.5 7.5zm-2.246-8.275-14.5-3.5-.47 1.944 14.5 3.5zM1.028 2.235l3.5 14.5 1.944-.47-3.5-14.5zM5.304 17.48l7.5 1.5.392-1.962-7.5-1.5zm8.403 1.226 5-5-1.414-1.414-5 5zm-12.414-16 7.586 7.586 1.414-1.414-7.586-7.586zM12 11a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1a1 1 0 0 1-1-1H8a3 3 0 0 0 3 3zm-1-1a1 1 0 0 1 1-1V8a3 3 0 0 0-3 3zm1-1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3z'
    />
  </svg>
);
export default SvgPenTool;
